import { createContext, useContext, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const DeepLinkContext = createContext();

export const DeepLinkProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const query = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]);

  const getQueryParam = (key) => query.get(key);

  const setQueryParam = (key, value) => {
    const newQuery = new URLSearchParams(location.search);
    if (value === null || value === undefined) {
      newQuery.delete(key);
    } else {
      newQuery.set(key, value);
    }

    navigate({
      pathname: location.pathname,
      search: newQuery.toString(),
    }, { replace: true });
  };

  const value = {
    getQueryParam,
    setQueryParam,
    query,
  };

  return (
    <DeepLinkContext.Provider value={value}>
      {children}
    </DeepLinkContext.Provider>
  );
};

export const useDeepLink = () => useContext(DeepLinkContext);
